import { useState, useEffect } from 'react';

// Global sidebar state
let sidebarState = {
  isExpanded: true,
  listeners: new Set()
};

export const useSidebar = () => {
  const [isExpanded, setIsExpanded] = useState(sidebarState.isExpanded);

  useEffect(() => {
    const listener = () => setIsExpanded(sidebarState.isExpanded);
    sidebarState.listeners.add(listener);
    
    return () => {
      sidebarState.listeners.delete(listener);
    };
  }, []);

  const toggleSidebar = () => {
    sidebarState.isExpanded = !sidebarState.isExpanded;
    sidebarState.listeners.forEach(listener => listener());
  };

  return { isExpanded, toggleSidebar };
};
